export default __webpack_public_path__ + "static/zahnrad-526d4a79646071c6af9b1f3f0ccb98b5.png";